'use client';

import {
  AdditionalSettingsFormDynamic,
  BlockProps,
  ComponentBaseProps,
  FormDynamicVariantEnum,
} from '@sola/schema/lib/schema.js';
import {
  submitLeadChurchForm,
  submitSubscription,
} from '@sola/skippy-sdk/requests.js';

import { FormEmailSubscribe } from '../../../organisms/forms/form-email-subscribe/form-email-subscribe';
import { LeadForm } from '../../../organisms/forms/lead-form/lead-form';

export type FormDynamicCoreProps = BlockProps & ComponentBaseProps;

export const FormDynamicCore = ({ settings }: FormDynamicCoreProps) => {
  const formDynamicSettings = settings
    ? AdditionalSettingsFormDynamic.parse(settings)
    : undefined;

  // const formDynamicSettingsMock = {
  //   formType: 'lead',
  //   leadType: 'contactme',
  //   subscriptionCode: 'testID',
  //   phone: { hide: false, required: false },
  //   hasChurch: true,
  //   role: { hide: false, required: true },
  //   roles: ['pastor','churchStaff','congregant'],
  //   website: { hide: false, required: true },
  //   buttonText: 'Submit',
  // };

  if (!formDynamicSettings) {
    return;
  }

  return (
    <section className="component component--no-header">
      <div className="container">
        {formDynamicSettings.formType ===
          FormDynamicVariantEnum.enum.subscription && (
          <FormEmailSubscribe
            subscriptionCode={
              formDynamicSettings.subscriptionCode ?? 'Leads_General_Sign_Up'
            }
            onSubmit={submitSubscription}
            config={formDynamicSettings}
            isFirstNameRequired
            isLastNameRequired
          />
        )}
        {formDynamicSettings.formType === FormDynamicVariantEnum.enum.lead && (
          <LeadForm
            onSubmit={submitLeadChurchForm(
              formDynamicSettings.leadType ?? 'contactme',
              formDynamicSettings.subscriptionCode ?? 'Leads_General_Sign_Up',
            )}
            config={formDynamicSettings}
          />
        )}
        {formDynamicSettings.formType === FormDynamicVariantEnum.enum.event && (
          <div>coming soon</div>
        )}
      </div>
    </section>
  );
};
